import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "menu-fullscreen-loading"
}
const _hoisted_2 = {
  key: 1,
  class: "mix-view"
}
const _hoisted_3 = {
  key: 0,
  class: "mix-view-tracks-empty"
}
const _hoisted_4 = { class: "mix-view-status" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_mix_control = _resolveComponent("mix-control")!
  const _component_track_sorter = _resolveComponent("track-sorter")!
  const _component_track_waveform = _resolveComponent("track-waveform")!
  const _component_track_position_pointer = _resolveComponent("track-position-pointer")!
  const _component_track_timeline = _resolveComponent("track-timeline")!

  return (_ctx.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_loading, null, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
            _createTextVNode("Loading...", -1)
          ]))]),
          _: 1
        })
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createVNode(_component_mix_control, {
          onRewind: _ctx.rewind,
          "timeline-type": _ctx.timelineType,
          onTimelineType: _cache[0] || (_cache[0] = ($event: any) => (_ctx.timelineType = $event))
        }, null, 8, ["onRewind", "timeline-type"]),
        (_ctx.mixTracks.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, " This mix doesn't have any tracks. You might want to add some. "))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "mix-view-tracks",
              onScroll: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onVerticalScroll && _ctx.onVerticalScroll(...args)))
            }, [
              _createVNode(_component_track_sorter, {
                height: _ctx.blockHeight,
                "mix-tracks": _ctx.mixTracks
              }, null, 8, ["height", "mix-tracks"]),
              _createElementVNode("div", {
                ref: "wfsection",
                onMousedown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onWFMouseDown && _ctx.onWFMouseDown(...args))),
                onMousemove: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onWFMouseMove && _ctx.onWFMouseMove(...args))),
                onScroll: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onScrollChange && _ctx.onScrollChange(...args))),
                class: "mix-view-waveforms",
                style: _normalizeStyle({ height: `${_ctx.blockHeight}px` })
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mixTracks, (mixTrack) => {
                  return (_openBlock(), _createBlock(_component_track_waveform, {
                    key: mixTrack._id,
                    "mix-track": mixTrack,
                    "scroll-position": _ctx.scrollPosition
                  }, null, 8, ["mix-track", "scroll-position"]))
                }), 128)),
                _createVNode(_component_track_position_pointer),
                _createVNode(_component_track_timeline, {
                  top: _ctx.timelineVerticalPos,
                  "timeline-type": _ctx.timelineType
                }, null, 8, ["top", "timeline-type"])
              ], 36)
            ], 32)),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.status), 1)
      ]))
}